import { useState, useEffect, useCallback, createContext, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de AuthProvider');
  }
  return context;
};

const useAuthLogic = () => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const loadUser = useCallback(() => {
    try {
      const stored = localStorage.getItem("usuario");
      if (stored) {
        const userData = JSON.parse(stored);
        const userInfo = {
          id: userData.id || userData.id_usuario,
          nome_completo: userData.st_nome,
          email: userData.st_email,
          perfil: userData.perfil || userData.en_perfil,
          ...userData
        };
        
        setUser(userInfo);
        setIsAuthenticated(true);
        return userInfo;
      } else {
        setUser(null);
        setIsAuthenticated(false);
        return null;
      }
    } catch (error) {
      console.error('❌ Erro ao carregar usuário:', error);
      setUser(null);
      setIsAuthenticated(false);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.clear();
    setUser(null);
    setIsAuthenticated(false);
    window.location.href = "/login";
  }, []);

  const updateUser = useCallback((newData) => {
    setUser(prev => ({ ...prev, ...newData }));
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "usuario") {
        loadUser();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function(key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "usuario") {
        setTimeout(() => loadUser(), 100);
      }
    };

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      localStorage.setItem = originalSetItem;
    };
  }, [loadUser]);

  return {
    user,
    isAuthenticated,
    isLoading,
    loadUser,
    logout,
    updateUser
  };
};

export const AuthProvider = ({ children }) => {
  const authLogic = useAuthLogic();
  
  return (
    <AuthContext.Provider value={authLogic}>
      {children}
    </AuthContext.Provider>
  );
};


